
import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Plus, FileText, Users } from "lucide-react";
import { JobContractForm } from "./JobContractForm";
import { ContractTemplateManager } from "./ContractTemplateManager";
import { JobContractList } from "./JobContractList";

export function JobContractManagement() {
  const [activeTab, setActiveTab] = useState<"create" | "templates" | "contracts">("create");

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold">Arbeitsverträge verwalten</h2>
      </div>

      <div className="flex space-x-1 border-b">
        <button
          onClick={() => setActiveTab("create")}
          className={`px-4 py-2 text-sm font-medium rounded-t-lg ${
            activeTab === "create"
              ? "bg-primary/10 text-primary border-b-2 border-primary"
              : "text-gray-500 hover:text-gray-700"
          }`}
        >
          <Plus className="inline-block w-4 h-4 mr-2" />
          Neuer Vertrag
        </button>
        <button
          onClick={() => setActiveTab("templates")}
          className={`px-4 py-2 text-sm font-medium rounded-t-lg ${
            activeTab === "templates"
              ? "bg-primary/10 text-primary border-b-2 border-primary"
              : "text-gray-500 hover:text-gray-700"
          }`}
        >
          <FileText className="inline-block w-4 h-4 mr-2" />
          Vorlagen
        </button>
        <button
          onClick={() => setActiveTab("contracts")}
          className={`px-4 py-2 text-sm font-medium rounded-t-lg ${
            activeTab === "contracts"
              ? "bg-primary/10 text-primary border-b-2 border-primary"
              : "text-gray-500 hover:text-gray-700"
          }`}
        >
          <Users className="inline-block w-4 h-4 mr-2" />
          Verträge
        </button>
      </div>

      <div className="mt-6">
        {activeTab === "create" && <JobContractForm />}
        {activeTab === "templates" && <ContractTemplateManager />}
        {activeTab === "contracts" && <JobContractList />}
      </div>
    </div>
  );
}
